import { useAppStore } from '@/store/app-store'
import { ArchitectureDiagram } from '@/components/benchmark/ArchitectureDiagram'
import { BenchmarkControls } from '@/components/benchmark/BenchmarkControls'
import Box from '@cloudscape-design/components/box'
import Button from '@cloudscape-design/components/button'
import SpaceBetween from '@cloudscape-design/components/space-between'

export function AdHocRunSection() {
  const currentRun = useAppStore((s) => s.currentRun)
  const isRunning = useAppStore((s) => s.isRunning)
  const setPage = useAppStore((s) => s.setPage)

  const hasResults = currentRun && currentRun.results.length > 0
  const benchmarkComplete = hasResults && !isRunning

  return (
    <SpaceBetween size="l">
      <Box variant="p" color="text-body-secondary">
        Run a one-time benchmark against your enabled profiles. Results appear immediately.
      </Box>

      <ArchitectureDiagram />
      <BenchmarkControls />

      {benchmarkComplete && (
        <Box textAlign="center" padding={{ top: 'm' }}>
          <Button variant="primary" onClick={() => setPage('results')}>
            Show Results
          </Button>
        </Box>
      )}
    </SpaceBetween>
  )
}
